export const confirmed = '#5cb85c'

export const open = '#f0ad4e'
export const pending = '#3f97b3'

export const external = ['#3f97b3', '#9442bc', '#e77241']
